module.exports = __webpack_public_path__ + "img/third-left.6386ee17.png";